import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".CreditCardContentIcon-module_creditCardContentIcon__8B-as {\n  height: 24px;\n  position: absolute;\n  right: 0;\n  top: 5px;\n}";
var styles = {"creditCardContentIcon":"CreditCardContentIcon-module_creditCardContentIcon__8B-as"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=CreditCardContentIcon.module.scss.js.map
